import React from 'react';
import { useDispatch } from 'react-redux';
import { setVisitStatus } from '../../../redux/actions/meActions';
import ContainerHeader from '../../shared/container/ContainerHeader';
import ContainerTitle from '../../shared/container/ContainerTitle';
import VisitStatusSelect from '../../shared/select/visits/VisitStatusSelect';

const MyVisitsHeader = () => {
  const dispatch = useDispatch();

  const handleVisitStatusChange = (value) => {
    dispatch(setVisitStatus(value));
  };

  return (
    <ContainerHeader>
      <ContainerTitle title={'Візити'} />
      <div className="flex gap-x-4 justify-end items-center">
        <div className="text-xs sm:text-base">Статус: </div>
        <VisitStatusSelect setVisitStatus={handleVisitStatusChange} />
      </div>
    </ContainerHeader>
  );
};

export default MyVisitsHeader;
